import { render, staticRenderFns } from "./WebhookAdded.vue?vue&type=template&id=3a5e32f3&scoped=true"
import script from "./WebhookAdded.vue?vue&type=script&lang=js"
export * from "./WebhookAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5e32f3",
  null
  
)

export default component.exports